var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"hide-default-header":"","hide-default-footer":"","headers":_vm.headers,"items":_vm.errorList,"options":{ itemsPerPage: 999 }},scopedSlots:_vm._u([{key:"item.error",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.decodeHtml(_vm.getItemError(item))))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }